export default __webpack_public_path__ + "static/media/cp_ma_mcafee.47c25de9.svg";